<template>
<!-- 查看试管编号图片 -->
<el-dialog :visible.sync="showLargePic" :close-on-click-modal="false" :before-close="handleClose"
  title="查看图片">
  <div class="dialog-main-content">
    <img width="100%" :src="picUrl" alt="">
  </div>
</el-dialog>
</template>
<script>
export default {
  props: {
    showLargePic: {
      type: Boolean,
      default: false
    },
    picUrl: {
      type: String
    }
  },
  data() {
    return {
      specialIntroForm: {},
      formRules:{}
    }
  },
  async created() {
    
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('update:showLargePic', false)
    }
  }
};
</script>
<style lang="less" scoped>

</style>